// jquery does not currently support ES6 way of importing so we need to do it old school
var $ = require('jquery');
require('slick-carousel');

/**
 * Carousel
 * @class
 */
export class Carousel {
  constructor(private carouselSelector:string, private carouselSettings:Object) {

  }

  public start() {
    //console.log('start carousel');
    $(this.carouselSelector).slick(this.carouselSettings);
  }
}
